import React from 'react';
import styled from 'styled-components';
import { PriceTestProductSummary } from '@/features/details/price-test-reports/api';
import { HSpace } from '@/components/spacing';
import {
  DeskHidden,
  format,
} from '@/features/details/price-test-reports/shared';

export function MobileTileHeader({
  p: { image, title, totalItemsSoled, totalRevenue },
}: {
  p: PriceTestProductSummary;
}) {
  return (
    <DeskHidden>
      <Row>
        <ImageWrapper>
          <img src={image} alt={title} />
          <HSpace />
        </ImageWrapper>
        <Col>
          <ProductTitle>{title || ``}</ProductTitle>
          <Item>Units Sold: {format(totalItemsSoled || 0)}</Item>
          <Item>Total: ${format(totalRevenue || 0)}</Item>
        </Col>
      </Row>
    </DeskHidden>
  );
}

const Item = styled.span`
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.44;
  letter-spacing: -0.22px;
  color: #121920;
  font-family: Inter, serif;
  font-size: 1.4rem;
  flex: 1;
`;

const Col = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  margin-left: 2rem;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  font-family: Inter, serif;
  font-size: 1.3rem;
  font-weight: 600;

  img {
    border-radius: 8px;
    height: 140px;
    margin-left: 2rem;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.09), 0 1px 4px 0 rgba(7, 6, 6, 0.04);
    background-color: #f7f7f7;
  }
`;
const ProductTitle = styled.span`
  font-family: Inter, serif;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 1.6;
  flex: 1;

  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 80px;
  @media (max-width: 768px) {
    max-width: 150px;
  }
`;
const Row = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-bottom: 2rem;
`;
